import { axiosInstance } from "./axiosSetup";
import { handleErrors } from "./handleErrors";

// eslint-disable-next-line import/prefer-default-export
export async function getUsers(offset, perPage, sortBy, sortDir) {
  return axiosInstance
    .get(`admin/users?startrow=${offset}&maxrows=${perPage}&orderby=${sortBy}&orderdir=${sortDir}`)
    .catch(handleErrors);
}
